const routeConstant = {
  APP: "/",
  LOGIN: "/auth/login",
  RESETPASSWORD: "/auth/login/resetPassword",
  FORGOTPASSWORD: "/auth/login/forgotPassword",
  SIGNUP: "/auth/signup",
  CHANGEPASSWORD: "/orderManagement/changePassword",
  PROFILE: "/orderManagement/profile",
  CREATE_ORDER_MAIN: "/orderManagement/create-order",
  CREATE_ORDER: "/orderManagement/create-order/order-specifcs",

  LINE_DETAIL: "/orderManagement/create-order/line-details",

  ORDER_PLAN: "/orderManagement/create-order/order-plan",
  DOC_UPLOAD: "/orderManagement/create-order/e-doc-upload",
  CONFIRMATION: "/orderManagement/create-order/confirmation",

  //dashoard list edit routes
  EDIT_CREATE_ORDER_MAIN: "edit-order",
  EDIT_CREATE_ORDER: "/orderManagement/dashboard/edit-order/order-specifcs",
  EDIT_LINE_DETAIL: "/orderManagement/dashboard/edit-order/line-details",
  EDIT_ORDER_PLAN: "/orderManagement/dashboard/edit-order/order-plan",
  EDIT_DOC_UPLOAD: "/orderManagement/dashboard/edit-order/e-doc-upload",
  EDIT_CONFIRMATION: "/orderManagement/dashboard/edit-order/confirmation",

  //order list edit routes
  LIST_EDIT_CREATE_ORDER_MAIN: "edit-order",
  // EDIT_ORDER_ORDER: "/orderManagement/dashboard/edit-order/order-specifcs",
  LIST_EDIT_CREATE_ORDER:
    "/orderManagement/order-list/edit-order/order-specifcs",
  LIST_EDIT_LINE_DETAIL: "/orderManagement/order-list/edit-order/line-details",
  LIST_EDIT_ORDER_PLAN: "/orderManagement/order-list/edit-order/order-plan",
  LIST_EDIT_DOC_UPLOAD: "/orderManagement/order-list/edit-order/e-doc-upload",
  LIST_EDIT_CONFIRMATION: "/orderManagement/order-list/edit-order/confirmation",

  DASHBOARD: "/orderManagement/dashboard",
  ORDER_DASHBOARD_MILESTONE: "/orderManagement/dashboard/milestone",
  ORDER_LIST: "/orderManagement/order-list",
  ORDER_LIST_FULL: "/orderManagement/order-list/details",
  ORDER_LIST_FULL_MILESTONE: "/orderManagement/order-list/details/milestone",
  SYSTEM_LOG: "/orderManagement/system-log",
  ORDER_REPORT: "/orderManagement/order-report",
  SETTINGS: "/orderManagement/settings",
  CHAT: "/orderManagement/chat",
  HELP: "/orderManagement/help",
};

export default routeConstant;
